<template>
	<section v-loading="loading" class="document">
		<div class="body">
			<slot />
		</div>
		<div 
			ref="container" 
			class="container" 
			:style="{ height: calculatedHeight, overflowY: 'scroll', border: '1px solid gainsboro' }" 
			@scroll="scroll"
		>
			<div ref="content" />
		</div>
	</section>
</template>


<script>
    import Vue from 'vue';
    import { AsyncMixin, LocalPropsMixin } from 'pdk/mixins';
    import { http } from '@/services';


	export default {
		name: 'document',
		mixins: [AsyncMixin, LocalPropsMixin({
			src: {
				type: Object,
				default: null
			}
		})],
		props: {
			height: {
				type: [String, Number],
				default: 'auto'
			},
			param: {
				type: String,
				default: null
			}
		},
		data() {
			return {
			documentId: null
			};
		},
		computed: {
			calculatedHeight() {
				if(this.height == null) return 'auto';
				if(isNaN(this.height)) return this.height;

				return `${parseInt(this.height)}px`;
			}
		},
		watch: {
			'local.src'(newValue) {
				this.loadDocument();
			}
		},
		mounted() {
			this.loadDocument();
		},
		methods: {
			loadDocument() {
				if(this.local.src) {
					if (this.local.src.request) {
						this.async(http.post(this.local.src.url, this.local.src.request).then((response) => {
							this.documentId = response.data.ID;
							this.render(response.data.Text);
						}));
					}
					else {
						this.async(http.get(this.local.src.url).then((response) => {
							this.documentId = response.data.id;
							this.render(response.data.content);
						}));
					}
				}
				else {
					this.render(this.$el.childNodes[0].innerHTML);
				}
				
				// When a new document is loaded, scroll to the top of the document.
				this.$refs.container.scrollTo(0,0);
			},
			render(content) {
				if (this.param)
					content = content.replace(/\{0\}/g, this.param).replace(/\{1\}/g, this.param);

                const escapedHtml = content.replace(/'/g, "\\'");
                this.$refs.content.innerHTML = escapedHtml;
			},
			scroll(e) {
				var element = e.target;

				var pageHeight = this.$refs.content.offsetHeight,
					windowHeight = element.offsetHeight,
					scrollPosition = element.scrollY || element.pageYOffset || element.scrollTop || 0;

				// When the bottom of the document is reached, emit a 'read' event for the parent component to listen for.
				if(pageHeight <= Math.ceil(scrollPosition) + windowHeight) {
					this.$emit('read', this.documentId);
				}
			}
		}
	};
</script>


<style lang="scss">
@import '~@/assets/styles/references';

.document {
	.body { display: none; }
	iframe { width: 100%; min-height: 100px; border: 1px solid color(black, divider); border-radius: $border-radius; }
}
</style>
